import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ModalDirective, ToastService } from 'ng-uikit-pro-standard';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { UnidadMedidaService } from 'src/app/services/unidadmedida.service';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { SecurityService } from 'src/app/shared/services/security.service';

@Component({
  selector: 'app-unidadmedida-modal-add-edit',
  templateUrl: './modal-add-edit.component.html',
  styleUrls: ['./modal-add-edit.component.scss'],
  providers: [SecurityService],
})
export class UnidadMedidaModalAddEditComponent implements OnInit {

  // Modales
  @ViewChild('agregarUnidadMedida', { static: true }) modalAddEditUnidadMedida: ModalDirective;

  @Output() onAddEdit: EventEmitter<any> = new EventEmitter()

  // Form
  formData: FormGroup

  // Data &  Tmp
  optionsRubros: Array<any> = [];
  isEditing: boolean = false
  codigoEditado = 0
  private rutEmpresa: number

  // Utils

  constructor(
    private clog: ConsoleService,
    private unidadmedidaService: UnidadMedidaService,
    private fb: FormBuilder,
    private formValidatorsService: FormValidatorsService,
    private messageRendererService: MessageRendererService,
    private toastrService: ToastService,
    private accesolocalstorage: SecurityService,
  ) { }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa())
    this.createForm()
  }

  private createForm() {
    this.formData = this.fb.group({
      activo: [false, [Validators.required]],
      nombre: [null, [Validators.required, Validators.maxLength(15), Validators.minLength(5)]],
    });
  }

  show() {
    this.isEditing = false
    this.clearData()
    this.modalAddEditUnidadMedida.show()
  }

  hide() {
    this.modalAddEditUnidadMedida.hide()
  }

  load(unidad) {
    this.isEditing = true
    this.codigoEditado = unidad.codigo
    this.clearData()
    this.formData.get('activo').setValue(unidad.activo)
    this.formData.get('nombre').setValue(unidad.nombre)
    this.modalAddEditUnidadMedida.show()
  }

  clearData() {
    this.formValidatorsService.reset(this.formData)
  }

  addEdit() {
    this.formValidatorsService.validateAllFormFields(this.formData)
    if (!this.formData.valid)
      return

    const inputParams: any = {
      entidad: {
        activo: this.formData.get('activo').value,
        nombre: this.formData.get('nombre').value,
      }
    }
    if (this.isEditing)
      inputParams.entidad.codigo = this.codigoEditado

    this.unidadmedidaService.guardar(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }

      this.toastrService.success('Operación realizada con éxito')
      this.onAddEdit.emit(respuesta)
      this.hide()
    })
  }

}

